module.exports = __webpack_public_path__ + "static/img/forusbgc.2762243.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/forusbgc.png
// module id = oiA3
// module chunks = 1